import merge from 'lodash/merge';

export default class Access {
  static NAME = 'access';

  static getDetailsConfig = () => ({
    url: '/v2/oligos/plates/redirect-status',
  });

  constructor(accessData) {
    this.init(accessData);

    this.shouldRedirect = accessData.shouldRedirect;
    this.url = accessData.url;
  }

  init(data) {
    merge(this, data);
  }
}
